<template>
    <div class="comparison">
        <div class="text">
            <Heading :h="2" size="xxl" weight="regular">
                <span class="smaller">
                    {{ content.optimisedForUse}}
                </span><br/>
                <span class="emphasized"
                    v-if="preferences.language === 'hu'">
                    {{ content.forYou }}
                </span>
                <template v-else>
                    {{ content.optimised }}
                </template>
                <template>
                    <template
                        v-if="preferences.language === 'hu'">
                        {{ content.optimised }}
                    </template>
                    <span class="emphasized"
                        v-else>
                        {{ content.forYou }}
                    </span>
                </template>
            </Heading>
            <p class="description">
                {{ content.optimisedDescription }}
            </p>
            <div class="features">
                <div class="feature">
                    <Icon class="featureIcon"
                        size="l"
                        icon="dark_mode"/>
                    {{ content.darkMode }}
                </div>
                <div class="feature">
                    <Icon class="featureIcon"
                        size="l"
                        icon="auto_awesome"/>
                    {{ content.modernUI }}
                </div>
                <div class="feature">
                    <Icon class="featureIcon"
                        size="l"
                        icon="devices"/>
                    {{ content.responsive }}
                </div>
            </div>
        </div>
        <div class="sliders">
            <div class="slider desktop">
                <VueCompareImage
                    leftImage="/assets/img/landing/entry-creatillo-desktop.jpg"
                    rightImage="/assets/img/landing/entry-instagram-desktop.jpg"
                    :sliderLineWidth="2"
                    :handleSize="40"/>
            </div>
            <div class="slider mobile">
                <VueCompareImage
                    leftImage="/assets/img/landing/entry-creatillo-mobile.jpg"
                    rightImage="/assets/img/landing/entry-instagram-mobile.jpg"
                    :sliderLineWidth="2"
                    :handleSize="40"/>
            </div>
        </div>
    </div>
</template>

<script>
    import VueCompareImage from 'vue-compare-image'

    export default {
        name: 'Comparison',
        components: {
            VueCompareImage
        },
        props: {
            content: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .comparison {
        display: flex;
        justify-content: center;
    }

    .text {
        display: flex;
        flex-direction: column;
        max-width: 24rem;
        width: calc(100% - 14rem);
        margin-right: 4rem;
    }

    .smaller {
        font-size: 70%;
    }

    .emphasized {
        font-weight: 700;
    }

    .sliders {
        display: flex;
        position: relative;
    }

    .slider {
        border-radius: 1rem;
        overflow: hidden;
        touch-action: none;
        margin-left: 8rem;
        box-shadow: var(--shadow-xl);
        transition: $transition-eio-20;
        height: fit-content;
    }

    .desktop {
        max-width: 60rem;
        width: 100%;
        transform: rotate(2deg);

        &:hover {
            transform: rotate(2deg) translateY(-1rem) scale(1.03);
        }
    }

    .mobile {
        position: absolute;
        left: -6rem;
        bottom: -4rem;
        max-width: 14rem;
        width: 100%;
        border: var(--border-grey-300);
        transform: rotate(-2deg);

        &:hover {
            transform: rotate(-2deg) translateY(-1rem) scale(1.05);
        }
    }

    .features {
        display: flex;
        flex-direction: column;
        margin-top: 2rem;
    }

    .feature {
        display: flex;
        align-items: center;
        margin-bottom: 2rem;
        font-family: $font-secondary;

        &:last-of-type {
            margin: 0;
        }
    }

    .featureIcon {
        color: var(--color-primary-500) !important;
        cursor: default !important;
        margin-right: 2rem;
    }

    @media all and (max-width: 1600px) {
        .sliders {
            margin-right: -8rem;
        }
    }

    @media all and (max-width: 1200px) {
        .mobile {
            position: absolute;
            left: -5rem;
            bottom: -2rem;
            max-width: 11rem;
        }

        .slider {
            margin-left: 5rem;
        }

        .text {
            margin-right: 2.5rem;
        }
    }

    @media all and (max-width: 1024px) {
        .comparison {
            flex-direction: column;
        }

        .mobile {
            bottom: auto;
            top: -4rem;
            max-width: 15rem;
        }

        .text {
            margin: 0 0 4rem 14rem;
        }

        .description {
            margin-left: 4rem;
            order: 1;
        }

        .features {
            flex-direction: row;
            margin: 0 0 0 4rem;
        }

        .feature {
            margin: 0 2rem 1rem 0;
        }
    }

    @media all and (max-width: 880px) {
        .mobile {
            bottom: auto;
            top: -8rem;
            left: -7rem;
            max-width: 13rem;
        }

        .text {
            margin-left: 2rem;
            max-width: 100%;
            width: calc(100% - 2rem);
        }

        .description {
            margin-left: 12rem;
        }

        .features {
            flex-wrap: wrap;
        }
    }
</style>